import { gql } from "graphql-request";

export const GET_SETTINGS = gql`
  query ($input: GetScheduleDetailsInput) {
    getScheduleDetails(input: $input) {
      settings {
        nearest
        ocr_scan
        verification
        flow_type
        child_age_limit
        verbiage {
          almost_done
          to_confirm
          need_to_click
          was_sent
        }
        insurance_fields {
          carrier_required
          plan_name_required
          group_number_required
          phone_required
          member_id_required
          employer_name_required
          home_zip_required
          first_name_required
          last_name_required
          birth_date_required
        }
        thankyou_html
        thankyou_url
        confirm_token_expiry_in_min
        insurance_enabled
        hide_providers_selection
      }
    }
  }
`;

export const GET_LOCATIONS = gql`
  query ($input: GetScheduleDetailsInput) {
    getScheduleDetails(input: $input) {
      locations {
        location_id
        name
        address
        latitude
        longitude
        contact_no
        software
        nearest {
          location_id
          name
          address
          latitude
          longitude
          contact_no
          settings {
            timezone
            same_day_appt
            no_avail_message
            child_age_limit
          }
        }
        settings {
          timezone
          same_day_appt
          no_avail_message
          child_age_limit
          insurance_enabled
          hide_providers_selection
        }
        other_carrier_note
      }
    }
  }
`;

export const GET_SERVICES = gql`
  query ($input: GetScheduleDetailsInput) {
    getScheduleDetails(input: $input) {
      services {
        id
        name
        description
        age_type
        patient_type
        duration
        icon_url
      }
    }
  }
`;

export const GET_NEAREST_SERVICES = gql`
  query ($input: GetScheduleDetailsInput) {
    getScheduleDetails(input: $input) {
      services {
        id
        name
        description
        age_type
        patient_type
        duration
      }
    }
  }
`;

export const GET_INSURANCES = gql`
  query ($input: GetScheduleDetailsInput) {
    getScheduleDetails(input: $input) {
      insurances {
        id
        name
        notes
      }
    }
  }
`;

export const GET_PROVIDERS = gql`
  query GetProviders($input: GetProvidersInput) {
    getProviders(input: $input) {
      provider_id
      first_name
      last_name
      middle_initial
      suffix
      npi
      specialty_description
    }
  }
`;

export const GET_NEAREST_SERVICES_PROVIDERS = gql`
  query GetProviders($input: GetProvidersInput) {
    getProviders(input: $input) {
      provider_id
      first_name
      last_name
    }
  }
`;

export const GET_AVAILABILITY = gql`
  query GetAvailability($input: GetAvailabilityInput!) {
    getAvailability(input: $input) {
      date
      times {
        start
        end
        operatory_id
        hash
      }
    }
  }
`;

export const GET_AVAILABILITY_CHUNK = gql`
  query GetAvailabilityChunk($input: GetAvailabilityInput!) {
    getAvailabilityChunk(input: $input) {
      date
      data {
        date
        times {
          start
          end
          operatory_id
          hash
        }
      }
    }
  }
`;

export const GET_APPOINTMENT_STATUS = gql`
  query GetAppointmentStatus($token: String!) {
    getAppointmentStatus(token: $token) {
      status
      error
    }
  }
`;

export const CONFIRM_APPOINTMENT = gql`
  mutation ($input: ConfirmAppointmentInput!) {
    confirmAppointment(input: $input) {
      patient {
        first_name
        last_name
        middle_initial
        home_phone
        mobile_phone
        work_phone
        birth_date
        gender
        email
      }
      appointment {
        appointment_length
        appointment_datetime
        appointment_notes
        service_id
        appointment_source
      }
      provider {
        provider_id
        first_name
        last_name
        middle_initial
        suffix
        npi
        specialty_description
      }
      location {
        location_id
        name
      }
      status_url
      settings {
        nearest
        verification
        flow_type
        child_age_limit
        verbiage {
          almost_done
          to_confirm
          need_to_click
          was_sent
        }
        insurance_fields {
          carrier_required
          group_number_required
          phone_required
          member_id_required
          employer_name_required
          home_zip_required
          first_name_required
          last_name_required
          birth_date_required
        }
        thankyou_html
        thankyou_url
        confirm_token_expiry_in_min
      }
    }
  }
`;

export const GET_SAMEDAY_AVAILABILITY = gql`
  query ($location_id: Int!) {
    getSameDayAvailability(location_id: $location_id) {
      service {
        id
        name
        description
        duration
        age_type
        patient_type
      }
      provider_id
      availability {
        date
        times {
          start
          end
          operatory_id
          hash
        }
      }
    }
  }
`;

export const GET_IDENTIFICATION_CARD_SCAN_INFO = gql`
  query ($input: OcrScanPayload!) {
    scanIdQuery(input: $input) {
      first_name
      last_name
      middle_initial
      email
      gender
      mobile_phone
      address
      city
      zip
      state
      dob
    }
  }
`;

export const GET_INSURANCE_CARD_SCAN_INFO = gql`
  query ($input: OcrScanPayload!) {
    scanInsuranceCardQuery(input: $input) {
      employer_name
      plan_name
      home_zipcode
      insurance_id
      insurance_carrier_name
      group_number
      insurance_phone_number
      member_id_number
      policy_holders_firstname
      policy_holders_lastname
      policy_holders_dob
    }
  }
`;

export const GET_SECONDARY_INSURANCE_CARD_SCAN_INFO = gql`
  query ($input: OcrScanPayload!) {
    scanSecondaryInsuranceCardQuery(input: $input) {
      secondary_employer_name
      secondary_plan_name
      secondary_home_zipcode
      secondary_insurance_id
      secondary_insurance_carrier_name
      secondary_group_number
      secondary_insurance_phone_number
      secondary_member_id_number
      secondary_policy_holders_firstname
      secondary_policy_holders_lastname
      secondary_policy_holders_dob
    }
  }
`;
